module.exports = __webpack_public_path__ + "static/img/teens_bg.61458476.png";